import { Trash2, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog';

/**
 * AlertDialog de confirmation pour supprimer une invitation
 */
export default function AlertDialogDeleteInvitation({ open, onOpenChange, invitation, onConfirm, isLoading }) {
    const { t } = useTranslation();
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle className="flex items-center gap-2">
                        <Trash2 className="h-5 w-5 text-destructive" />
                        {t('procedures:supprimerLInvitation')}
                    </AlertDialogTitle>
                    <AlertDialogDescription>
                        {t('procedures:voulezVousVraimentSupprimerLInvitationEnvoyeeA')}{' '}
                        <span className="font-medium text-foreground">{invitation?.email}</span> ?
                        <br />
                        <br />
                        {t('procedures:cetteActionEstIrreversibleLInvitationSeraDefinit')}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel disabled={isLoading}>{t('procedures:annuler')}</AlertDialogCancel>
                    <AlertDialogAction
                        onClick={onConfirm}
                        disabled={isLoading}
                        className="bg-destructive hover:bg-destructive/90 text-destructive-foreground"
                    >
                        {isLoading ? (
                            <>
                                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                                {t('procedures:suppression')}
                            </>
                        ) : (
                            t('procedures:supprimer')
                        )}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
